import React from 'react'
import HeroSection from '../Components/HeroSection'
import About from '../Components/About'
import Services from '../Components/Services'
import History from '../Components/History'
import Portfolio from '../Components/Portfolio'
import Testimonial from '../Components/Testimonial'
import Contact from '../Components/Contact'
import Footer from '../Components/Footer'

const Home = () => {
  return (
    <>
      <HeroSection/>
      <About/>
      <Services/>
      <History/>
      <Portfolio/>
      <Testimonial/>
      <Contact/>
      <Footer/>
    </>
  )
}

export default Home
